import Repository from './Repository';

const resource = '/oc';

export default {
    getActiveElectionYears() {
        return Repository.get(`${resource}/read/election/active`)
    },
    getElectionInfoByYear(year) {
        return Repository.get(`${resource}/read/election/year/${year}`)
    },
    getContestByElectionId(electionId) {
        return Repository.get(`${resource}/read/election/${electionId}/contest`)
    },
    getCandidateAvaliableLanguagesByContestId(contestId) {
        return Repository.get(`${resource}/p/published/${contestId}/candidates`)
    },
    getPublishedCandidateStatements(contestId, candidateId) {
        return Repository.get(`${resource}/p/published/${contestId}/${candidateId}`)
    },
    getCandidateStatementListByCandidateIdAndContestId(contestId, candidateId) {
        return Repository.get(`${resource}/p/published/${contestId}/${candidateId}`)
    },
}